<template>
	<div>
		<a-form-model ref="theForm" layout="inline" :model="theObj" :rules="rules">
			<a-form-model-item label="权限名称"  prop="RoleName">
				<a-input v-model="theObj.RoleName"/>
			</a-form-model-item>
			<a-form-model-item label="备注">
				<a-input v-model="theObj.Remark"/>
			</a-form-model-item>
		</a-form-model>
		<a-tree  checkable  :tree-data="treeData" :replaceFields="replaceFields"  v-model="checkList"  @check="onCheck"/>
		<div class="drawerFooter" v-if="addFlag||editFlag">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
	
</template>

<script>
	export default{
		props:['theObj','editFlag'],
		data(){
			return {
				rules:{
					RoleName:[{required:true,message:'请输入权限名称',trigger: 'blur'}],
				},
				replaceFields:{
					title:'Remark',
					key:'AuthorityCode'
				},
				treeData:[],
				checkList:[],
				selectedIdList:[],
				submitFlag:false,
			}
		},
		methods:{
			getRoleAuthorityData:function(){
				let url = this.Api.getLastUrl(this.Api.ROLE_AUTHORITY_URL);
				let param = {roleId:this.theObj.PID};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.treeData = data.data.result;
					for(var i=0;i<this.treeData.length;i++){
						let nodeData = this.treeData[i];
						let subList = nodeData.children;
						for(var j=0;j<subList.length;j++){
							let subNode = subList[j];
							if(subNode.checked == 1){
								this.checkList.push(subNode.AuthorityCode);
							}
						}
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			onClose:function(flag){
				this.$emit('onClose');
				if(flag){
					this.$emit('refreshList');
				}
			},
			onSubmit:function(){
				this.$refs.theForm.validate(valid => {
					if(valid) {
						if(this.checkList.length == 0){
							this.$message.error('请选择权限');
						}else{
							if(this.addFlag && !this.editFlag){
								this.addSubmit();
							}else if(this.editFlag && !this.addFlag){
								this.editSubmit();
							}
						}
					} else {
						return false;
					}
				});
			},
			editSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.ROLE_AUTHORITY_EDIT_URL);
				let str = this.getLastAuthIds();
				let param = {
					roleName:this.theObj.RoleName,
					remark:this.theObj.Remark,
					roleId:this.theObj.PID,
					authIds:str,
				}
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.onClose(true);
						this.$message.success('修改成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				});
			},
			addSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.ROLE_AUTHORITY_ADD_URL);
				let str = this.getLastAuthIds();
				let param = {
					roleName:this.theObj.RoleName,
					remark:this.theObj.Remark,
					authIds:str,
				}
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.onClose(true);
						this.$message.success('新增成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				});
			},
			onCheck:function(checkedKeys) {
				this.checkList = checkedKeys;
			},
			getLastAuthIds:function(){
				for(var m = 0;m<this.checkList.length;m++){
					let key = this.checkList[m];
					for(var i=0;i<this.treeData.length;i++){
						let nodeData = this.treeData[i];
						let subList = nodeData.children;
						for(var j=0;j<subList.length;j++){
							let subNode = subList[j];
								if(subNode.AuthorityCode == key && subNode.PPID >0 ){
									let id = subNode.PID;
									this.selectedIdList.push(id);
									break;
								}
							}
						}
				}
				
				let ss = this.selectedIdList.join(",");
				console.log(ss);
				return  ss;
			}
		},
		created() {
			this.getRoleAuthorityData();
		},
		computed:{
			addFlag:function(){
				return this.theObj.PID ==0;
			}
		}
	}
</script>
<style>
</style>
